import React from 'react'
import type { PresentationBlockProps } from '../..'
import compareBlockProps from '../../util/compareBlockProps'
import { InlineEditableHtml } from '../../inlineEditable'

function TextBlock(props: PresentationBlockProps) {
  const { block, WrapperComponent, isSettings, blockPrefix, isEditable, presetColors, setFieldValue, submitForm } =
    props

  const { fields } = block

  const handleEditField = (field: string, content: string) => {
    setFieldValue(`${blockPrefix}.${field}`, content)
    submitForm()
  }

  return (
    <WrapperComponent {...props}>
      <InlineEditableHtml
        placeholderButtonText={'Add Text'}
        isEditable={isEditable}
        isSettings={isSettings}
        handleEdit={(content) => handleEditField('fields.content', content)}
        content={fields.content}
        presetColors={presetColors}
        fieldKey={`${blockPrefix}.fields.content`}
      />
    </WrapperComponent>
  )
}

export default React.memo(TextBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
